<template>
  <div class="flex items-center w-full">
    <div class="flex items-center w-full">
      <feather-icon :class="actionElementCss" v-if="done" icon="CheckSquareIcon" class="w-5 mr-2 cursor-pointer" @click="toggleDone(!done)" />
      <feather-icon :class="actionElementCss" v-else icon="SquareIcon" class="w-5 mr-2 cursor-pointer" @click="toggleDone(!done)" />

      <vs-input v-if="editing" autofocus autocomplete="off" class="inputx skeleton-input" ref="skeleton_input_edit" @keyup.enter.native="save" @focusout="save" v-model="title" />
      <!-- <DoubleClick v-else @doubleClick="startEditing"> -->
      <AnchoredTitle v-else :title="subtask.title"  :titleClasses="done ? 'text-muted line-through' : ''"/>

      <!-- <span  v-else :class="done ? 'text-muted line-through' : ''">{{subtask.title}}</span> -->
      <!-- </DoubleClick> -->
    </div>
    <div class="flex justify-end ml-1">
      <feather-icon icon="EditIcon" :class="actionElementCss" class="w-4" @click.prevent="startEditing" />
      <feather-icon icon="TrashIcon" :class="actionElementCss" class="w-4 ml-1" @click="$emit('subtaskDelete', subtask)" />
    </div>

  </div>
</template>

<script>
import DoubleClick from '../Generic/DoubleClick'

export default {
  components: {
    DoubleClick,
  },
  data () {
    return {
      editing: false,
      title: null

    }
  },
  props: {
    subtask: {
      type: Object,
      required: true,
    },
    task: {
      type: Object,
      required: true,
    },
  },
  computed: {
    done () { return this.subtask.done }
  },
  watch: {
    'editing': {
      immediate: false,
      handler (editing) {
        if (editing) {
          this.$forceNextTick(() => this.$refs['skeleton_input_edit'].focusInput())
        }
      }
    }
  },
  methods: {
    startEditing () {
      this.title = this.subtask.title
      this.editing = true
    },
    save () {
      this.editing = false

      if (this.title !== this.subtask.title) {
        if (this.title) {
          this.$emit('subtaskEdit', { ...this.subtask, title: this.title })
        } else {
          console.log('delete')
        }
      }
    },
    toggleDone (done) {
      this.$emit('subtaskEdit', { ...this.subtask, done })
    },
  }
}
</script>
